/* eslint import/no-webpack-loader-syntax: off */
require('expose-loader?BVLazyLoad!../../src/utils/lazy_load');
